import type { EnrollmentCreateResponseOneOfThreeResult } from './enrollmentCreateResponseOneOfThreeResult';

export type EnrollmentCreateResponseOneOfThree = {
  /** 에러 코드 */
  errorCode: string;
  /** 실패 사유 */
  reason: string;
  result: EnrollmentCreateResponseOneOfThreeResult;
};
